<template>
  <div>
    <transition name="media-scale">
      <div class="media-scale">
        <el-dialog
          v-bind="$attrs"
          v-on="$listeners"
          :key="'dialog'"
          :visible="isShowRedPacketRecord"
          :modal="false"
          :close-on-click-modal="false"
          :title="$t('redpacket.giveRecord')"
          width="770px"
          class="dialog-dark dialog-center form-dark"
          @close="onClose"
        >
          <el-table
            :data="recordData"
            :height="420"
            class="table-dark table-noborder"
          >
            <el-table-column
              prop="userName"
              :label="$t('redpacket.initiator')"
              width="180px"
            >
              <template slot-scope="scope">
                <p class="fontsize14">{{ scope.row.userName }}</p>
                <p class="greyColor">{{ scope.row.startTime }}</p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('redpacket.packetType')">
              <template slot-scope="scope">
                <p class="fontsize14" v-if="scope.row.type == 0">
                  {{ $t("redpacket.normal") }}
                </p>
                <p class="fontsize14" v-if="scope.row.type == 1">
                  {{ $t("redpacket.passwd") }}
                </p>
                <p class="fontsize14" v-if="scope.row.type == 2">
                  {{ $t("redpacket.redPacketRain") }}
                </p>
                <p class="greyColor">
                  {{ scope.row.drawCount }}/{{ scope.row.sendCount
                  }}{{ $t("redpacket.aleryReceive") }}
                </p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('redpacket.packetAllPrice')" width="150">
              <template slot-scope="scope">
                <p class="fontsize14">
                  {{ (scope.row.amount/100).toFixed(2) }}{{ $t("redpacket.yuan") }}
                </p>
                <p class="greyColor">
                  {{ $t("redpacket.surplus")
                  }}{{ (scope.row.restAmount/100).toFixed(2)
                  }}{{ $t("redpacket.yuan") }}
                </p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('redpacket.status')">
              <template slot-scope="scope">
                <p class="fontsize14" v-if="scope.row.status == 0">
                  {{ $t("redpacket.未充值") }}
                </p>
                <p class="fontsize14" v-if="scope.row.status == 1">
                  {{ $t("redpacket.未开始") }}
                </p>
                <p class="fontsize14" v-if="scope.row.status == 2">
                  {{ $t("redpacket.进行中") }}
                </p>
                <p class="fontsize14" v-if="scope.row.status == 3">
                  {{ $t("redpacket.已结束") }}
                </p>
                <p class="fontsize14" v-if="scope.row.status == 4">
                  {{ $t("redpacket.已停止") }}
                </p>
              </template>
            </el-table-column>
            <el-table-column :label="$t('redpacket.handle')">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 1">
                  <el-popconfirm
                    ref="popconfirm"
                    :title = "$t('record.你确定要停止该红包吗')"
                    icon="el-icon-info"
                    placement="top"
                    icon-color="#EA494B"
                    @confirm="stop(scope.row.id)"
                  >
                    <span
                      slot="reference"
                      class="blueColor fontsize14"
                      @click.stop=""
                      >{{ $t("redpacket.stop") }}</span
                    ></el-popconfirm
                  >
                </p>
                <!-- 回头把4去掉 -->
                <p
                  v-if="scope.row.status == 2 || scope.row.status == 3"
                  @click="goLook(scope.row)"
                  class="blueColor fontsize14"
                >
                  {{ $t("redpacket.look") }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Table, TableColumn } from "element-ui";
import { getRedpacketList, stopRedpacket } from "@/api/redPacket";
import Bus from "@/components/doc/bus";
import { pushRoomMessageFunc,removeMessageFunc } from "@/utils/socketMessageDispose";
export default {
  name: "record",
  computed: {
    ...mapGetters(["isShowRedPacketRecord", "confId", "liveId", "userInfo"]),
  },
  components: { [Table.name]: Table, [TableColumn.name]: TableColumn },
  data() {
    return {
      recordData: [],
    };
  },
  mounted() {
    pushRoomMessageFunc(this.getCvMcRoomMessage);
  },
  beforeDestroy() {
    removeMessageFunc();
  },
  watch: {
    isShowRedPacketRecord: {
      handler(value) {
        if (value) {
          this.getRedpacketRecordList();
        }
      },
    },
  },
  methods: {
    onClose() {
      this.$store.commit("SET_SHOW_RED_PACKET_RECORD", false);
    },
    async getRedpacketRecordList() {
      const recordInfo = {
        cid: this.userInfo.cid,
        confId: this.confId,
        liveId: this.liveId,
        pageNo: 0,
        pageSize: 99,
        statusList: [0, 1, 2, 3, 4],
        typeList: [0, 1, 2],
      };
      const { status, message, data } = await getRedpacketList(recordInfo);
      if (status == 0) {
        // this.recordData = data;
        const data1 = data.filter((info) => {
          return info.status == 1 || info.status == 2;
        });
        const data2 = data.filter((info) => {
          return info.status != 1 && info.status != 2;
        });
        this.recordData = [...data1, ...data2];
      } else {
        this.$message.error(message);
      }
    },
    // 去查看
    goLook(info) {
      Bus.$emit("idList", info);
      this.$store.commit("SET_SHOW_RED_PACKEY_DETAIL", true);
    },
    // 停止红包
    async stop(redpacketId) {
      const { status, message } = await stopRedpacket({
        cid: this.userInfo.cid,
        redpacketId,
      });
      if (status == 0) {
        this.getRedpacketRecordList();
      } else {
        this.$message.error(message);
      }
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
        case 7125: {
          // this.disposeCustomMessage_7125(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      console.log(this.isShowRedPacketRecord);
      console.log(requestData.type);

      if (requestData.event) {
        switch (requestData.event) {
          case "redpacketEvent": {
            if (
              this.isShowRedPacketRecord &&
              (requestData.type == "send" ||
                requestData.type == "end" ||
                requestData.type == "stop" ||
                requestData.type == "create")
            ) {
              this.getRedpacketRecordList();
            }
          }
        }
      }
    },
    disposeCustomMessage_7125(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "redpacketEvent": {
            // if (requestData.type == "pay_success") {
            // }
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.blueColor {
  color: #3986eeff;
  cursor: pointer;
}
.fontsize14 {
  font-size: 14px;
}
.greyColor {
  color: #acb2bf;
  font-size: 12px;
}
</style>
